import { Col, Form, Radio, Row, Space } from 'antd';
import React from 'react';
import { useLocalization } from '../../../util/useLocalization';
import { MassAssignFieldTypesProps } from '../MassAssignFieldTypes';
import { Locale } from '../../../../localization/LocalizationKeys';
import {
  MassAssignFieldAction,
} from '../../../../gql/typings';
import SiteAssignFormInput from '../../site/components/SiteAssignFormInput';

const MassAssignEntitySearchType: React.FC<MassAssignFieldTypesProps> = ({
  heading,
  isHeadingKey,
  entityType,
  actionName,
  valueSelected: [, setValueSelected],
  actionSelected: [actionSelected, setActionSelected],
}) => {
  const localization = useLocalization();
  return (
    <div className="mass-assign-container">
      <div className="mass-assign-type-description">
        <p>
          {localization.formatMessage(Locale.Text.Mass_assign_description_selectionType,
            { value: isHeadingKey ? localization.formatMessageByStr(heading) : heading })}
        </p>
      </div>

      <div className="dashboard-card-container">
        <div className="mass-assign-content-container">
          <Form.Item
            name="actionName"
            style={{ display: 'none' }}
            initialValue={actionName}
          />
          <Form.Item
            name="entityType"
            style={{ display: 'none' }}
            initialValue={entityType}

          />
          <Row>
            <Col span={12}>
              <h3>{localization.formatMessage(Locale.Text.Action)}</h3>
              <Form.Item
                name="actionType"
                initialValue={MassAssignFieldAction.SetValueToSelected}
              >
                <Radio.Group>
                  <Space direction="vertical">
                    <Radio
                      onClick={() => setActionSelected(MassAssignFieldAction.SetValueToSelected)}
                      value={MassAssignFieldAction.SetValueToSelected}
                    >{localization.formatMessage(Locale.Text.Mass_assign_action_set_value_to_selected)}</Radio>
                    <Radio
                      onClick={() => setActionSelected(MassAssignFieldAction.BlankOutField)}
                      value={MassAssignFieldAction.BlankOutField}
                    >{localization.formatMessage(Locale.Text.Mass_assign_action_set_blank_out)}</Radio>
                  </Space>
                </Radio.Group>
              </Form.Item>

            </Col>
            <Col span={12}>
              <h3>Select value</h3>
              <Form.Item
                name="singleSelectValue"
              >
                <SiteAssignFormInput
                  onValueSelect={() => setValueSelected(true)}
                  disabled={actionSelected === MassAssignFieldAction.BlankOutField}
                />
              </Form.Item>
            </Col>

          </Row>
        </div>

      </div>


    </div>
  );
};


export default MassAssignEntitySearchType;
